<div class="sd-form um">
  <div class="sd-form__head">
    <div class="sd-form__head-text">
      <h3 class="sd-form__title">{{ title }}</h3>
      <p class="sd-form__subtitle" *ngIf="step === 'plans' && plans">
        You’re on <strong>{{ currentPlanLabel }}</strong>.
        <ng-container *ngIf="canManageBilling">Change plan whenever you like.</ng-container>
      </p>
    </div>
    <button type="button" class="sd-icon-btn" aria-label="Close" (click)="close()" [disabled]="step === 'confirming'">
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <div class="sd-form__body um__body" [class.um__body--roomy]="roomy">

    <!-- Loading -->
    <div class="um-plans" *ngIf="step === 'loading'" aria-busy="true">
      <div class="um-plan um-plan--skeleton" *ngFor="let _ of [1, 2]">
        <span class="um-skel um-skel--title"></span>
        <span class="um-skel um-skel--price"></span>
        <span class="um-skel"></span>
        <span class="um-skel"></span>
      </div>
    </div>

    <!-- Plans -->
    <ng-container *ngIf="step === 'plans'">
      <p class="um-note" *ngIf="!canManageBilling">
        Only an admin of this organisation can change its plan. Ask one of them to upgrade{{ options?.featureName ? ' to use ' + options.featureName : '' }}.
      </p>

      <p class="um-note" *ngIf="!tiers.length">
        There are no plans to choose from right now. Please contact support to upgrade.
      </p>

      <div class="um-plans" *ngIf="tiers.length">
        <div class="um-plan" *ngFor="let tier of tiers; trackBy: trackTier"
             [class.is-recommended]="tier.code === recommendedCode" [class.is-current]="tier.isCurrent">
          <div class="um-plan__head">
            <span class="um-plan__name">{{ tier.name }}</span>
            <span class="um-badge um-badge--current" *ngIf="tier.isCurrent">Current plan</span>
            <span class="um-badge" *ngIf="!tier.isCurrent && tier.code === recommendedCode">Recommended</span>
          </div>

          <ul class="um-plan__features" *ngIf="tier.features.length">
            <li *ngFor="let feature of tier.features" [class.is-highlight]="feature.code === options?.requiredFeature">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ feature.name }}</span>
            </li>
          </ul>
          <p class="um-plan__desc" *ngIf="!tier.features.length && tier.prices[0]?.description">{{ tier.prices[0].description }}</p>

          <div class="um-plan__prices">
            <button type="button" class="sd-btn um-price" *ngFor="let price of tier.prices; let first = first; trackBy: trackPrice"
                    [class.sd-btn--primary]="first && tier.code === recommendedCode && !isCurrentPrice(price)"
                    [class.sd-btn--secondary]="!first || tier.code !== recommendedCode || isCurrentPrice(price)"
                    [disabled]="!canManageBilling || isCurrentPrice(price)"
                    (click)="choose(tier, price)">
              <span>{{ isCurrentPrice(price) ? 'Your plan' : 'Choose' }}</span>
              <span class="um-price__amount">{{ priceLabel(price) }}</span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- New subscription: Stripe's own checkout form, inside this modal -->
    <ng-container *ngIf="step === 'checkout'">
      <div class="um-checkout-loading" *ngIf="busy">
        <mat-spinner [diameter]="24"></mat-spinner>
        <span>Opening secure checkout…</span>
      </div>
      <!-- Stripe's form carries the plan, price, terms and "Powered by Stripe" itself. -->
      <div class="um-checkout" #checkoutHost></div>
    </ng-container>

    <!-- Existing subscriber: change of plan -->
    <ng-container *ngIf="step === 'change'">
      <div class="um-summary" *ngIf="selectedTier">
        <div class="um-summary__row">
          <span>New plan</span>
          <strong>{{ selectedTier.name }} · {{ priceLabel(selectedPrice) }}</strong>
        </div>
        <div class="um-summary__row" *ngIf="preview">
          <span>Charged now</span>
          <strong>{{ money(preview.amountDue, preview.currency) }}</strong>
        </div>
        <p class="um-summary__hint" *ngIf="preview">
          The difference for the rest of this billing period, charged to the card on file. Your renewal date doesn’t change.
        </p>
        <div class="um-checkout-loading" *ngIf="busy && !preview">
          <mat-spinner [diameter]="20"></mat-spinner>
          <span>Working out the difference…</span>
        </div>
      </div>
      <p class="sd-form__error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </ng-container>

    <!-- Waiting for the new plan to come through -->
    <div class="um-state" *ngIf="step === 'confirming'">
      <mat-spinner [diameter]="32"></mat-spinner>
      <h4 class="um-state__title">Payment received</h4>
      <p class="um-state__text">Switching on your new plan…</p>
      <p class="um-state__text um-state__text--muted" *ngIf="slowConfirm">This is taking a little longer than usual.</p>
    </div>

    <!-- Done -->
    <div class="um-state" *ngIf="step === 'done'">
      <span class="um-state__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <h4 class="um-state__title">You’re on {{ selectedTier?.name }}</h4>
      <p class="um-state__text" *ngIf="!pending">
        {{ options?.featureName ? options.featureName + ' is ready to use.' : 'Your new features are ready to use.' }}
      </p>
      <p class="um-state__text" *ngIf="pending">
        Your payment went through. It can take a minute for everything to switch on — you don’t need to do anything.
      </p>
    </div>

    <!-- SD-1229: a plan Synced manages -->
    <div class="um-state" *ngIf="step === 'managed'">
      <h4 class="um-state__title">Your plan is managed by Synced</h4>
      <p class="um-state__text">
        You’re on <strong>{{ plans?.currentPlan?.name }}</strong>, which we set up and invoice for you.
        <ng-container *ngIf="options?.featureName">To add {{ options.featureName }}, </ng-container>
        <ng-container *ngIf="!options?.featureName">To change it, </ng-container>
        get in touch at <a [href]="supportMailto">{{ supportEmail }}</a>.
      </p>
    </div>

    <!-- Error -->
    <div class="um-state" *ngIf="step === 'error'">
      <h4 class="um-state__title">Something went wrong</h4>
      <p class="um-state__text">{{ errorMessage }}</p>
    </div>
  </div>

  <div class="sd-form__footer">
    <ng-container [ngSwitch]="step">
      <ng-container *ngSwitchCase="'checkout'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="back()">Back to plans</button>
      </ng-container>
      <ng-container *ngSwitchCase="'change'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="back()" [disabled]="busy">Back</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="confirmChangePlan()" [disabled]="busy || !preview">
          Confirm change
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'confirming'"></ng-container>
      <ng-container *ngSwitchCase="'managed'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Close</button>
        <a class="sd-btn sd-btn--primary" [href]="supportMailto">Contact Synced</a>
      </ng-container>
      <ng-container *ngSwitchCase="'done'">
        <button type="button" class="sd-btn sd-btn--primary" (click)="close()">Continue</button>
      </ng-container>
      <ng-container *ngSwitchCase="'error'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Close</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="load()">Try again</button>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Not now</button>
      </ng-container>
    </ng-container>
  </div>
</div>
